import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { rootRoutes } from './app.route';
import { AuthGuard } from './shared/auth-guards/auth.guard';
import { LoginService } from './login/login.service';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { AppUtils } from './app.utils';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { UserProfileService } from './user-profile/user-profile.service';
import { AppService } from './app.service';
import { LoginAuthGuard } from './shared/auth-guards/login-auth.guard';
import { PermissionService } from './shared/permissions/permissions.service';
import { MessageService } from 'primeng/api';
import localeFr from '@angular/common/locales/fr';
import { registerLocaleData } from '@angular/common';
import { ManageHttpRequestsInterceptor } from './manage-http-requests.interceptor';
import { HttpCancelService } from './http-cancel.service';

export function HttpLoaderFactory(httpBackend: HttpBackend): TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(httpBackend));
}

registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    SharedModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
    }),
    RouterModule.forRoot(rootRoutes, { useHash: true })
  ],
  providers: [
    AppUtils,
    AuthGuard,
    LoginAuthGuard,
    AppService,
    LoginService,
    MessageService,
    UserProfileService,
    PermissionService,
    { provide: HTTP_INTERCEPTORS, useClass: ManageHttpRequestsInterceptor, multi: true },
    HttpCancelService
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
